import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { ApiError, RoleListParams, RoleListResponse } from '@app/services/api.types';

type QueryOptions = Omit<UseQueryOptions<RoleListResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchRoleList = async (params: RoleListParams): Promise<RoleListResponse> => {
	const url = apiEndpoints.role.getList(params);
	const response = await api.get(url);
	return response?.data;
};

const useRoles = (params: RoleListParams, options?: QueryOptions) => {
	return useQuery<RoleListResponse, ApiError>({
		queryKey: ['role', 'list', params],
		queryFn: () => fetchRoleList(params),
		...options,
	});
};

export default useRoles;
